import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7db265c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "404",
  class: "edit-page-100"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<section class=\"error-container\" data-v-7db265c6><span class=\"error-span\" data-v-7db265c6>4</span><span class=\"error-span\" data-v-7db265c6><span class=\"screen-reader-text\" data-v-7db265c6>0</span></span><span class=\"error-span\" data-v-7db265c6>4</span></section>", 1)
const _hoisted_3 = { class: "d-flex align-items-center justify-content-center margin-top-20" }
const _hoisted_4 = { class: "text-color-gray" }
const _hoisted_5 = { class: "margin-top-20 d-flex align-items-center justify-content-center" }

import i18n from "@/core/i18n/i18n";
import { router } from "@/core/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'NotFound',
  setup(__props) {

const { t } = i18n.global;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(t)("Common.404")), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: "btn btn-oneTeg2",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/')))
      }, _toDisplayString(_unref(t)("Auth.Home")), 1)
    ])
  ]))
}
}

})